import { Box, Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { H5 } from '../../components/typography';
import { useAPI } from '../../hooks/useAPI';
import Button from '../../components/button';

const VerifySignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getAuthSession } = useAPI();
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    const getSession = async () => {
      const queryParameters = new URLSearchParams(window.location.search);
      const sessionId = queryParameters.get('grandidsession');
      if (!sessionId) {
        setError('Kunde inte logga in, vänligen försök igen');
        return;
      }
      const res = await getAuthSession(sessionId);
      if (!res) {
        setError('Kunde inte logga in, vänligen försök igen');
        return;
      }
      navigate('/');
    };
    getSession();
  }, [navigate, getAuthSession]);

  return (
    <Container maxWidth="sm">
      <H5>{t('bank_id_verify')}</H5>
      {!!error && (
        <Box mt={3}>
          <H5>{error}</H5>
          <Button onClick={() => navigate('/')}>Tillbaka till logga in</Button>
        </Box>
      )}
    </Container>
  );
};

export default VerifySignIn;
